export enum Medium {
  'electricity' = 'electricity',
  'water' = 'water',
  'gas' = 'gas',
}
